import { render, staticRenderFns } from "./Vk.vue?vue&type=template&id=9a530d26&scoped=true&"
import script from "./Vk.vue?vue&type=script&lang=js&"
export * from "./Vk.vue?vue&type=script&lang=js&"
import style0 from "./Vk.vue?vue&type=style&index=0&id=9a530d26&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a530d26",
  null
  
)

export default component.exports